import React from "react";
import { waLink } from "@/lib/api";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = ({ phone, message, label, testid, className = "", size = "sm" }) => {
  if (!phone) return null;
  const cls = size === "icon"
    ? "inline-flex items-center justify-center w-7 h-7 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white"
    : "inline-flex items-center gap-1 h-8 px-2.5 rounded-md bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-semibold";
  return (
    <a href={waLink(phone, message)} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} title={`WhatsApp ${phone}`} className={`${cls} ${className}`} data-testid={testid}>
      <MessageCircle className="w-3.5 h-3.5" />{size !== "icon" && <span>{label || "WhatsApp"}</span>}
    </a>
  );
};
